<style scoped>
.steps {
    border: 1px solid #e7e7e7
}

.steps-header {
    padding: .375rem;
    border-bottom: 1px solid #e7e7e7
}

.steps-header .progress {
    height: .25rem
}

.steps-body {
    display: table;
    table-layout: fixed;
    width: 100%
}

.step {
    display: table-cell;
    position: relative;
    padding: 1rem .75rem;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    border-right: 1px dashed #dfdfdf;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 600;
    text-align: center;
    text-decoration: none
}

.step:last-child {
    border-right: 0
}

.step-indicator {
    display: block;
    position: absolute;
    top: .75rem;
    left: .75rem;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid #e7e7e7;
    border-radius: 50%;
    background-color: #fff;
    font-size: .875rem;
    line-height: 1.375rem
}

.has-indicator {
    padding-right: 1.5rem;
    padding-left: 2.375rem
}

.has-indicator .step-indicator {
    top: 50%;
    margin-top: -.75rem
}

.step-icon {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 auto;
    margin-bottom: .75rem;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    color: #888
}

.step:hover {
    color: rgba(0, 0, 0, 0.9);
    text-decoration: none
}

.step:hover .step-indicator {
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    border-color: transparent;
    background-color: #f4f4f4
}

.step:hover .step-icon {
    color: rgba(0, 0, 0, 0.9)
}

.step-active,
.step-active:hover {
    color: rgba(0, 0, 0, 0.9);
    pointer-events: none;
    cursor: default
}

.step-active .step-indicator,
.step-active:hover .step-indicator {
    border-color: transparent;
    background-color: #5c77fc;
    color: #fff
}

.step-active .step-icon,
.step-active:hover .step-icon {
    color: #5c77fc
}

.step-completed .step-indicator,
.step-completed:hover .step-indicator {
    border-color: transparent;
    background-color: rgba(51, 203, 129, 0.12);
    color: #33cb81;
    line-height: 1.25rem
}

.step-completed .step-indicator .feather,
.step-completed:hover .step-indicator .feather {
    width: .875rem;
    height: .875rem
}

.btn-show-order {
    width: 20%;
}

@media (max-width: 575.98px) {
    .btn-show-order {
        width: 100%;
    }
    .steps-header {
        display: none
    }
    .steps-body,
    .step {
        display: block
    }
    .step {
        border-right: 0;
        border-bottom: 1px dashed #e7e7e7
    }
    .step:last-child {
        border-bottom: 0
    }
    .has-indicator {
        padding: 1rem .75rem
    }
    .has-indicator .step-indicator {
        display: inline-block;
        position: static;
        margin: 0;
        margin-right: 0.75rem
    }
}

.bg-secondary {
    background-color: #f7f7f7 !important;
}

.d-none-width {
    width: 300px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 190px;
}

@media only screen and (max-width: 600px) {
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
  .bottom-title-left {
      text-align: right;
  }
  .bottom-title-right {
      text-align: right;
  }
  .right-side-info {
    text-align: center;
  }

  .left-side-info {
    text-align: center;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container">
                <div class="my-md-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-3 flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble">
                            <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1"><router-link to="/home">Нүүр хуудас</router-link></li>
                            <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1"><a href="javascript:;">Үйлчилгээний нөцхөл</a></li>
                        </ol>
                    </nav>
                </div>
                <div class="row mt-5">
                    <div class="col-md-2"></div>
                    <div class="col-md-8" align="center" :style="{'font-size': '18px'}">

                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-1"></div>
                    <div class="col-md-10 mt-5">
                        <el-collapse v-model="activeNames" >
  <el-collapse-item  name="1"><template slot="title"><span class="font-size-16">Нэг. Нийтлэг үндэслэл</span></template>
    <div><span> 
        1.1.  Энэхүү үйлчилгээний нөхцөл нь “АЙ СИ БИ СИ "ХХК -ийн харилцагч БНХАУ дахь икэа брэндийн бүтээгдэхүүнийг  www.ikealab.mn вэбсайтаар дамжуулан борлуулах, хүргэх болон хэрэглэгч худалдан авахтай холбоотой үүсэх харилцааг зохицуулна.
       <br> 1.2.  Энэхүү журам нь хэрэглэгч худалдаа хийх, вэбсайтаар үйлчлүүлэхээсээ өмнө хүлээн зөвшөөрч баталгаажуулсны үндсэн дээр хэрэгжинэ.
       <br> 1.3.  Энэхүү үйлчилгээний журмын хэрэгжилтэнд “АЙ СИ БИ СИ ХХК”  /цаашид байгууллага гэх/ болон хэрэглэгч /цаашид хэрэглэгч гэх/ нар хамтран хяналт тавина.
       <br> 1.4   www.ikealab.mn нь зөвхөн интернетээр дамжуулан худалдаа үйлчилгээ явуулах зорилготой байнгын ажиллагаатай вэбсайт байна. 
       <br> 1.5  www.ikealab.mn онлайн худалдааны вэбсайт нь 24 цагийн ажиллагаатай бөгөөд ИКЭА брэндийг Монгол улсын нутаг дэвсгэрт албан ёсоор төлөөлөхгүй болно.
       <br> 1.6  “ikealab.mn” тэмдэгт нь АЙ СИ БИ СИ ХХК – ийн өмч байх бөгөөд энэхүү вэбсайтын нэр, лого, загвар, баннер зэргийг олшруулах болон өөр бусад зорилгоор ашиглахыг хориглоно.
       <br> 1.7  Байгууллага тухайн вэбсайтын мэдээллийн шинэчлэл, үнийн шинэчлэл, урамшуулал болон шинэ үйлчилгээний мэдээлэлийг Хятад улс дахь тус тухайн вэб сайтын мэдээллийг ямар ч өөрчлөлтгүйгээр Монгол улс дахь хэрэглэгчиддээ цаг алдалгүй дамжуулах ажлыг бүрэн хариуцна.
       <br> 1.8  Хэрэглэгч вэбсайтын талаар санал гомдол, шүүмж зэргийг вэбсайтын журмын дагуу чөлөөтэй илэрхийлэх, илгээх эрхтэй.
       <br> 1.9 Энэхүү үйлчилгээний нөхцөлд заасан дараах нэр томьёог дор дурьдсан утгаар ойлгоно. Үүнд:
       <br> 1.9.1 “Компани” гэдэгт www.ikealab.mn вэбсайтыг өмчлөгч “АЙ СИ БИ СИ ” ХХК-ийг
       <br> 1.9.2  “Хэрэглэгч” гэдэгт www.ikealab.mn сайтад бүртгүүлсэн этгээдийг;
       <br> 1.9.3  “Захиалагч” гэдэгт www.ikealab.mn  вэб сайтаас худалдан авалт хийхээр захиалга үүсгэж, баталгаажуулсан этгээдийг;
       <br> 1.9.4 “Вэбсайт” гэж ‘’IKEA’’ брэндийн бараа бүтээгдэхүүн, үйлчилгээг хэрэглэгчдэд санал болгох, худалдан авалт, захиалгыг цахимаар хийх үйлчилгээг үзүүлж буй албан цахим хуудас https://ikealab.mn/ -г;
       <br> 1.9.5 “Нийлүүлэгч” гэдэгт өөрийн өмчлөлийн бараа бүтээгдэхүүнийг худалдаалахаар www.ikealab.mn вэб сайтад байршуулсан, Компанитай хамтран ажиллах гэрээ байгуулсан этгээдийг тус тус ойлгоно.
       <br>1.10 Хэрэглэгч нь иргэний эрх зүйн бүрэн чадамжтай иргэн байх бөгөөд насанд хүрээгүй хүүхэд эцэг эхийн хамт үйлчилгээний нөхцлийн дагуу худалдан авалт хийх боломжтой.

    </span></div>
  </el-collapse-item>
  <el-collapse-item title="Feedback" name="2"><template slot="title"><span class="font-size-16">Хоёр. Захиалга баталгаажуулалт</span></template>
    <div><span> 
             2.1 Хэрэглэгч “ikealab.mn” цахим худалдааны системийг ашиглан 24 цагийн аль ч цагт, хэдэн удаа ч захиалга хийж болно. 
       <br>  2.2 Хэрэглэгч өөрийн facebook хаяг болон цахим хаягаараа бүртгэл үүсгэн худалдан авалт хийх боломжтой.
       <br>  2.3 Вэбсайт нь хэрэглэгч захиалгыг зааврын дагуу захиалгын нийт үнийн дүнг 100 хувь шилжүүлснээр урьдчилан хүлээн авснаар захиалга автоматаар баталгаажна.
       <br>  2.4 Вэбсайт нь хэрэглэгчийн захиалгын төлбөр албан ёсны дансанд зааврын дагуу үнэн зөв хийгдсэн тохиолдолд тухайн захиалгыг албан ёсоор баталгаажсан гэж үзнэ.
       <br>  2.5 Захиалга хийх, төлбөрийг шилжүүлэх, бараа, бүтээгдэхүүн хүлээж авах бүрд хэрэглэгчийн бүртгүүлсэн цахим шуудан болон гар утсанд Вэбсайт-c мэдэгдэл илгээнэ.
       <br>  2.5 Захиалгын төлбөр холбогдох дансанд орж ирээгүй тохиолдолд захиалга автоматаар цуцлагдана. Цуцлагдсан захиалгыг дахин сэргээх боломжгүй бөгөөд хэрэглэгч хүсвэл захиалгыг дахин шинээр хийх боломжтой.
       <br>  2.6 Хэрэглэгч нь худалдан авалтын захиалгатай холбоотой асуудлаар ажлын өдрүүдэд 9-19 цагийн хооронд, амралтын өдрүүдэд 10-20 цагийн хооронд 
         ikeaLAB mn пэйж хуудас, түүний чат болон 7511-4532 утсаар  холбогдож мэдээлэл авах, тодруулах боломжтой.

    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="3"><template slot="title"><span class="font-size-16">Гурав. Цахим зээлийн үйлчилгээний нөхцөл</span></template>
    <div><span> 
        3.1 Вэбсайтын санал болгож буй бүх бараа бүтээгдэхүүн, үйлчилгээнээс Хаан банкны цахим зээлээр худалдан авах боломжтой бөгөөд Хэрэглэгч зээлээр авах сонголтыг сонгож өөрийн мэдээллээ үнэн зөв бөглөнө. 
       <br> 3.2 Цахим зээлийн хүсэлт нь зээл олгогч Хаан банк эсвэл банк бусын аппликэшний үйл ажиллагааны журам шаардлагын дагуу судлагдаж эхлэнэ. 
       <br> 3.3 Та зээлийн төлбөрөө гэрээнд заасан хуваарийн дагуу төлөх үүрэгтэй бөгөөд ийнхүү төлснөөр дараа дараагийн зээл авах эрх, боломж нэмэгдэх боломжтой. Харин зээлээ төлөөгүй тохиолдолд таны мэдээлэл Монголбанкны зээлийн мэдээллийн санд бүртгэгдэж дахин өөр банк, санхүүгийн байгууллагаас зээл авах боломжгүй болно.

    </span></div>
  </el-collapse-item>
  <el-collapse-item title="Controllability" name="4"><template slot="title"><span class="font-size-16">Дөрөв. Үнэ ба төлбөр</span></template>
    <div><span> 
        4.1 Вэбсайтад байрласан бараа үйлчилгээний үнэ нь банкны шимтгэл, хураамж (qpay, socialpay г.м), нэмэгдсэн эцсийн жижиглэн худалдаалах үнэ байх ба тухайн барааны овор жингээс хамааран нэмэлт тээвэрийн төлбөр бодогдох боломжтой байна.
    <br> 4.2 Компани тухайн захиалгын үйлчилгээг хүргэсэний төлбөр тухайн барааны үнийн дүнгээс хамаарч үйлчилгээний хөлс 5,000-50,000төгрөг байна.
    <br> 4.3 Хэрэглэгч төлбөрийн дараах хэлбэрүүдийг www.ikealab.mn -с  худалдан авах боломжтой ба интернет банк, мобайл банкаар төлбөр хийх, эсвэл QR код уншуулах тохиолдолд гүйлгээний утга дээр өөрийн IK захиалгын дугаарыг заавал бичнэ. <br>

<span class="ml-8"> Интернет банк болон мобайл банкаар төлбөрөө шилжүүлэх</span><br>
<span class="ml-8"> QR код уншуулах</span><br>
<span class="ml-8"> Голомт банкны карт</span><br>
<span class="ml-8"> Хаан банк онлайн лизинг</span><br>
<span class="ml-8"> Qpay</span><br>
<span class="ml-8"> Монпэй</span><br>
<span class="ml-8"> Storepay хувааж төлөх </span><br>
<span class="ml-8"> Pocket хувааж төлөх  </span>
<br> 4.4 Хэрэглэгч захиалга хийж баталгаажуулсны дараа цахим хэлбэрээр захиалгын хуудасны мэдээлэл авна. Компани захиалгын мэдээллийг илгээхдээ захиалгын нийт дүн, төлбөр гүйцэтгэх хэлбэр, төлбөр хүлээн авагч байгууллагын нэр, дансны дугаар зэргийг хэрэглэгчдэд дэлгэрэнгүй хүргэнэ.
<br> 4.5 Хэрэглэгчийн хийсэн захиалга бүр дахин давтагдашгүй захиалгын дугаартай байх бөгөөд “Миний Булан” хэсгээс өөрийн захиалгын тухай дэлгэрэнгүй мэдээллийг харах боломжтой.
<br> 4.6 Захиалга хийсэн ч төлбөр шилжүүлээгүй нөхцөлд захиалга баталгаажихгүй.
<br> 4.7 Хэрэглэгч вэбсайтад байгаа барааны дэлгэрэнгүй танилцуулга, үйлчилгээний нөхцөлтэй сайтар танилцаж, захиалгаа давхар нягтлах үүрэгтэй бөгөөд  төлбөр төлөгдсөний дараа захиалгаа цуцлах тохиолдолд хэрэглэгчийн төлбөрийг буцаалтын нөхцөлийн дагуу шилжүүлнэ. 
<br> 4.8 Хэрэглэгчийн захиалсан барааны загвар зөрсөн, гэмтэлтэй байсан тохиолдолд Вэбсайт нь тус барааг солиулах эсвэл төлбөрийг буцаан олгох сонголтыг олгоно. 
<br> 4.9 Хэрэглэгчийн захиалсан бараа тээвэрлэлтийн явцад гэмтсэн тохиолдолд сайт уг хохирлыг нэн даруй барагдуулж буцааж авах эсвэл хэрэглэгч зөвшөөрсөн тохиолдолд дахин захиалж өгнө.
<br> 4.10  Вэбсайт-д барааны загвар, бүтээгдэхүүний нэр, код зэрэг мэдээлэл байгаа тул бусад мэдээллийн сувгийг ашиглан тус барааны талаар мэдээлэл, бусад орны хэрэглэгчдийн санал гомдлыг судлах боломжтой.
<br> 4.11 Захиалга буцаах үед хэрэглэгчид захиалгын төлбөрийг буцаан шилжүүлэхдээ ашигласан төлбөрийн хэрэгслийн сонголтоос хамааран тухайн банк болон ББСБ-н нөхцлийн дагуу гүйлгээний шимтгэл 1-3%-ийг хасч буцаан шилжүүлнэ.

    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="5"><template slot="title"><span class="font-size-16">Тав. Хүргэлтийн үйлчилгээний нөхцөл</span></template>
    <div><span> 
        5.1 Вэбсайт нь хүргэлтийн үйлчилгээг зөвхөн Улаанбаатар хотод үзүүлэх ба хэрэглэгчийн хүсэлтээр орон нутагт хүргэх тохиолдолд орон нутгийн унаанд дамжуулан хүлээлгэн өгөх ба дамжуулан хүргүүлснээс үүдсэн эрсдийг хариуцахгүй болно. 
       <br> 5.2 Захиалгыг баталгаажуулсан хугацаа, тээвэрлэлт, аюулгүй байдал зэргээс хамаарч захиалгыг Улаанбаатар хотод ирсэнээс хойш 24-48 цагт хүргэнэ.
       <br> 5.3 Хэрэглэгч вэбсайтаас бараа үйлчилгээ захиалан хүргүүлэхдээ хүргэлтийн хаягийг үнэн зөв, дэлгэрэнгүй бичих мөн холбоо барих өөрийн болон хоёрдогч гар утасны дугаарыг бичиж үлдээх ба шаардлагатай үед хүргэлтийн ажилтан залгахад дуудлага хүлээн авах үүрэгтэй. 
       <br> 5.4 Бараа захиалгын тээвэрлэлт, хүргэлтийг "Магнет карго" ХХК хүргэлтийн мэргэжлийн байгууллага хариуцаж гүйцэтгэх тул хүргэлтийн явцад захиалсан бараа гэмтэл, сэвтэлтэй ирсэн тохиолдолд дээрх байгууллага бүрэн хариуцаж арга хэмжээ авна..
       <br> 5.5 Хот доторх хүргэлт нь хотын дараах хязгааруудад хийгдэнэ:
       <br><span class="ml-8">А. СХД: 22-ын товчоо, Орбит, Толгойт,Баянхошуу</span><br>
       <span class="ml-8">Б. ЧД: Чингэлтэй, 7 буудал</span><br>
       <span class="ml-8">В. СБД: Дамбадаржаа</span><br>
       <span class="ml-8">Г. БЗД: Улиастай, Баянзүрхийн товчоо</span><br>
       <span class="ml-8">Д. ХУД: Нисэх буудлын дэргэдэх товчоонууд гэсэн цэгүүдээр тогтооно.</span>
      <br> 5.6 Вэбсайт нь хот доторх хүргэлт болон хотоос гадагш хүргэлтийн төлбөр болон хугацааны хувьд барааны овор хэмжээ, тээвэрлэлтийн нөхцөл, хотын бүсчлэлээс хамааруулж тогтоосон Магнет карго ХХК-ны үнэ тариф, хугацааг мөрдөнө. 
      <br> 5.7 Бараа захиалгын хэрэглэгчид хүргэх дундаж хугацаа 14-18 хоног байна.
      <br> 5.8 Бараа хүргэгч барааг худалдан авагчид хүлээлгэн өгөхөөс өмнө хүлээн авагчийн утасны дугаар мэдээллийг шалгана. Худалдан авсан барааг бараа хүргэгч нь бүрэн бүтэн байдал, иж бүрдлийг нь сайтар шалгаж худалдан авагчид хүлээлгэн өгнө.
      <br> 5.9 Худалдан авагч нь барааны худалдан авсан барааны бүрэн байдал, иж бүрдэл, тээвэрлэлтийн гэмтэл болон дагалдах бэлэг урамшууллыг шалгаж хүлээж авсны дараа хүргэлтийн баримт дээр гарын үсэг зурснаар бүрэн бүтэн хүлээн авсанд тооцно.
      <br> 5.10 Худалдан авагч хүргэлтээ ямар нэг шалтгаанаар аваагүй /утсаа аваагүй, хүргэлтийн хаягт очиход хүлээн авах боломжгүй байх г.м /тохиолдолд хүргэлт дараагийн өдөрт шилжүүлнэ. 
      <br> 5.11 Онлайн зээлээр худалдан авсан Хэрэглэгч зээлийн гэрээн дээр баталгаат гарын үсэг зурах шаардлагатай тул тухайн зээл гаргач өөрөө хүргэлтийн бараа бүтээгдэхүүнээ хүлээн авах үүрэгтэй.
    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="6"><template slot="title"><span class="font-size-16">Зургаа. Бараа солих ба буцаалт</span></template>
    <div><span> 
        6.1 Хэрэглэгчийн сэтгэл ханамжаас хамааран барааг өөр бараагаар солих буцаах боломжгүй. 
       <br> 6.2 Хүргэж өгсөн бараа үйлдвэрийн, тээвэрлэлтийн, хадгалалтын гэмтэлтэй тохиолдолд шинэ эсвэл ижил бараагаар үнэ төлбөргүй дахин захиалж өгөх эсвэл төлбөрийг буцаан олгоно.
       <br> 6.3 Төлбөрийг бэлнээр буцааж байгаа тохиолдолд хэрвээ хэрэглэгч НӨАТ-ийн барим бүртгэгдсэн тохиолдолд НӨАТ -ийн 10% - ийн шимтгэлийг хасч шилжүүлнэ.
       <br> 6.4 Буцаалтын үнийн дүнгээс гүйлгээний нэмэлт шимтгэл /банкны шимтгэл хураамж (qpay, socialpay г.м), 1% - ийг хасч шилжүүлнэ.
    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="7"><template slot="title"><span class="font-size-16">Долоо. Баталгааны нөхцөл</span></template>
    <div><span> 
        7.1 Вэбсайт нь борлуулагдаж байгаа зарим нэг электрон бараанд нийлүүлэгчийн жураманд заагдсан тохиолдолд түүний дагуу БАТАЛГААТ ХУГАЦААГ хэрэглэгчиддээ олгоно. 
        <br> 7.3 Хэрэглэгчийн зүгээс үүдсэн механик гэмтэл буюу үйлдвэрийн бус гэмтэлд “АЙ СИ БИ СИ” ХХК ямарваа нэгэн хариуцлага хүлээхгүй болно. 
        <br> 7.4 ikealab.mn сайтаар худалдан борлуулагдсан бараа бүтээгдэхүүний баталгаат хугацаа болон нөхцөлийг нийлүүлэгч байгууллагын баталгааны журмыг үндэслэн худалдан авагчдад зуучлан худалдаалсан болно. 
        <br> 7.5 ikealab.mn сайт нь нийлүүлэгчийн баталгаат хугацааны нөхцөлөөс бусад баталгааг гарган өгч үүрэг хүлээхгүй бөгөөд нийлүүлэгч байгууллагын баталгаат засварын дүгнэлтэд үндэслэн хэрэглэгчийн хүсэлтийг шийдвэрлэнэ. 
    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="8"><template slot="title"><span class="font-size-16">Найм. Давагдашгүй хүчин зүйлс</span></template>
    <div><span> 
        8.1 Гэнэтийн болон давагдашгүй хүчин зүйл, бүх нийтийн амралтын өдрүүд, эрх бүхий байгууллага, албан тушаалтны шийдвэрээр хил, гаалийн үйл ажиллагаа саатах, цаг агаарын байдал, хорио цээрийн дэглэм тогтоосон, гамшгийн нөхцөл байдал үүссэн болон бусад хүчин зүйлийн улмаас тодорхой хугацаагаар хүргэлтийн хугацаа хойшлогдож болно. Компани нөхцөл байдлаас шалтгаалан хүргэлтийн хугацаа хойшлогдсон талаар болон хүргэх боломжтой хугацааг хэрэглэгчид нэн даруй мэдэгдэнэ. 
    </span></div>
  </el-collapse-item>
  <el-collapse-item  name="9"><template slot="title"><span class="font-size-16">Ec: Бусад заалт </span></template>
    <div><span> 
        9.1 Хэрэглэгчээс гарсан гомдол, маргаантай асуудлыг вэбсайтын үйлчилгээний нөхцөл, нууцлалын баталгаа болон Монгол улсын хууль дүрмийн дагуу шийдвэрлэнэ.
   <br> 9.2 Вэбсайт нь үйлчилгээний нөхцөлдөө өөрчлөлт оруулах эрхтэй бөгөөд өөрчлөлт оруулсан тохиолдолд тухай бүр нийтэд нээлттэй байршуулах ба Хэрэглэгч худалдан авалт хийх бүртээ үйлчилгээний нөхцөлтэй танилцах үүрэг хүлээнэ.
   <br> 9.3 Хэрэглэгчийг захиалга хийгдэх үед хүчинтэй байсан үйлчилгээний нөхцөл захиалгыг хүргэх шатанд өөрчлөгдсөн тохиолдолдбараа, бүтээгдэхүүнийг хүлээж авах хүртэл өмнөх үйлчилгээний нөхцлийг үндэслэх ба бусад тохиолдолд шинэ нөхцлийг хүчин төгөлдөрт тооцох болно.

    </span></div>
  </el-collapse-item>
   </el-collapse>
                    </div>
                </div>
            </div>
        </main>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
export default {
    components: {
        Brands
    },
    data() {
        return {
            dialogTableVisible: false,
            fullscreenLoading: false,
            data: false,
            step: 0,
            progress: 0,
            searchInput: '',
            activeNames:['1'],
            order: {
                invoiceId: '',
                created_at: '',
                status: '',
                product: []
            }
        }
    },
    mounted() {
        this.$emit('getJquery');
    },
    methods: {

    }
}
</script>